<template>
    <div class="wrap clearfix">
        <div class="row">
            <div class="col-md-12">
                <img src="/static/surprised-goat.svg" class="goat" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 text-center">
                <h1>404</h1>
                <p>How did you get here? You need to re-think some life choices and try again.</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
    h1 {
        font-size: 80px;
        margin-top: 20px;
    }

    .wrap {
        margin-top: 8%;
    }

    .goat {
        width: 15%;
    }

    p {
        margin-top: 20px;
        font-size: 22px;
    }
</style>